import React from "react";
import { Link } from "react-router-dom";
import { brand, nav, locations, services, socials } from "../data/siteData";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__orbit" aria-hidden="true" />
      <div className="container footer__grid">
        <div className="footer__brand">
          <span className="footer__logo">{brand.name}</span>
          <p>{brand.supporting}</p>
        </div>

        <div className="footer__col">
          <h4>Navigation</h4>
          <ul>
            {nav.map((item) => (
              <li key={item.path}>
                <Link to={item.path}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h4>Locations</h4>
          <ul>
            {locations.map((loc) => (
              <li key={loc.id}>
                <Link to={`/locations/${loc.slug}`}>{loc.city}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h4>Services</h4>
          <ul>
            {services.slice(0, 4).map((s) => (
              <li key={s.id}>{s.name}</li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h4>Contact</h4>
          <ul>
            {locations.map((loc) => (
              <li key={loc.id}>{loc.phone}</li>
            ))}
          </ul>
          <div className="footer__socials">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.label}
              >
                {s.label[0]}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="container footer__bottom">
        <span>© {new Date().getFullYear()} {brand.name}. All rights reserved.</span>
      </div>
    </footer>
  );
}
